module.exports = __webpack_public_path__ + "img/47_9.a94589c4.png";